import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";
import { User } from "../models/user.model";

interface UserAgent {
    id: string;
    details: any;
}
[];

type State = {
    user?: User;
    userAgents: UserAgent[];
};

type Action = {
    setUser: (user?: User) => void;
    setUserAgents: (userAgents: UserAgent[]) => void;
};

const initialState: State = {
    user: undefined,
    userAgents: [],
};

export const useUserStore = create(
    persist(
        devtools<State & Action>((set) => ({
            ...initialState,

            setUser: (value) =>
                set({
                    user: value,
                }),

            setUserAgents: (value) =>
                set({
                    userAgents: value,
                }),
        })),
        { name: "user-storage" }
    )
);
